import { Knower } from 'interfaces/Knower'
import { appKnowerProfileRoute, knowerProfileRoute } from 'lib/constants/routes'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { ReactNode } from 'react'
import styled from 'styled-components'

const LinkElement = styled.div`
    && {
        width: fit-content;
        max-width: fit-content;
        margin: 0;
        padding: 0;
        cursor: pointer;
    }
`

export const KnowerLink = (props: { knower: Knower; children: ReactNode; handleLinksWithinWebapp?: boolean }) => {
    const router = useRouter()

    const onKnowerLinkClick = () => {
        router.push(props.handleLinksWithinWebapp ? appKnowerProfileRoute(props.knower) : knowerProfileRoute(props.knower))
    }

    if (!props.knower.isSeoIndexed) return <LinkElement onClick={onKnowerLinkClick}>{props.children}</LinkElement>

    return (
        <LinkElement>
            <Link href={knowerProfileRoute(props.knower)}>{props.children}</Link>
        </LinkElement>
    )
}
